import { useTranslation } from 'react-i18next';

interface TutorialsHeroProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

const TutorialsHero = ({ activeCategory, onCategoryChange }: TutorialsHeroProps) => {
  const { t } = useTranslation();

  const categories = [
    { id: 'all', label: t('tutorials:categories.all'), icon: 'ri-apps-line' },
    { id: 'pdf-convert', label: t('tutorials:categories.pdfConvert'), icon: 'ri-file-pdf-line' },
    { id: 'image-convert', label: t('tutorials:categories.imageConvert'), icon: 'ri-image-line' },
    { id: 'pdf-tools', label: t('tutorials:categories.pdfTools'), icon: 'ri-tools-line' }
  ];

  return (
    <section className="pt-32 pb-16 bg-gradient-to-br from-teal-50 via-white to-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero Content */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-semibold mb-6">
            <i className="ri-book-open-line text-lg"></i>
            <span>{t('tutorials:hero.badge')}</span>
          </div>
          <h1 className="text-5xl font-bold text-gray-900 mb-6 font-['Space_Grotesk']">
            {t('tutorials:hero.title')}
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t('tutorials:hero.subtitle')}
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap justify-center gap-3">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => onCategoryChange(category.id)}
              className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === category.id
                  ? 'bg-teal-600 text-white shadow-lg shadow-teal-600/30'
                  : 'bg-white text-gray-700 hover:bg-gray-50 border-2 border-gray-200'
              }`}
            >
              <i className={`${category.icon} text-xl`}></i>
              <span>{category.label}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TutorialsHero;